module.exports = __webpack_public_path__ + "static/img/40014 (4).aa57e90.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40014 (4).webp
// module id = 641l
// module chunks = 14